module.exports = __webpack_public_path__ + "img/NL361.adb198d0.png";